export const revenueMoloniTranslationsEn = {
  expenses: { tabs: { revenue: 'Revenue', sales: 'Sales', invoicing: 'Invoicing' } },
  revenueReport: {
    downloadPdf: 'Download PDF',
    downloadCsv: 'Download CSV',
    totalReceived: 'Total received',
    totalVat: 'Total VAT',
    sales: '{{count}} sales',
    empty: 'No payments in this period.',
    show: 'Show',
    columns: {
      id: 'Id',
      date: 'Date',
      professional: 'Professional',
      customer: 'Customer',
      vat: 'Customer VAT',
      services: 'Services',
      products: 'Products',
      total: 'Total paid',
      tax: 'VAT',
      payment: 'Payment',
    },
  },
  salesList: {
    month: 'Month',
    professionals: 'Professionals',
    customers: 'Customers',
    invoiceStatus: 'Invoice status',
    allCustomers: 'All customers',
    issued: 'Issued',
    notIssued: 'Not issued',
    all: 'All',
    selectAll: 'Select all',
    issueSelected: 'Issue selected',
    selectedCount_one: '{{count}} sale selected',
    selectedCount_other: '{{count}} sales selected',
    empty: 'No sales for these filters.',
    progress: 'Issued {{issued}}, skipped {{skipped}}, failed {{failed}}.',
    searchCustomers: 'Search customers',
    previous: 'Previous',
    next: 'Next',
  },
  moloni: {
    title: 'Moloni',
    explanation: 'Connect the store Moloni account to issue an invoice-receipt when you choose to. Payments stay recorded even if invoicing is skipped.',
    connect: 'Connect to Moloni',
    company: 'Company',
    series: 'Invoice-receipt series',
    noSeries: 'This Moloni company has no document series.',
    save: 'Save',
    ready: 'Connected to {{company}}.',
    changeCompany: 'Change company',
    disconnect: 'Disconnect',
    disconnectTitle: 'Disconnect Moloni',
    disconnectMessage: 'This store will stop issuing invoice-receipts. Invoices already issued stay in Moloni.',
    issue: 'Issue invoice',
    resend: 'Resend to customer',
    issued: 'Issued',
    notIssued: 'Not issued',
    later: 'Not now',
    confirmTitle: 'Issue invoice-receipt',
    name: 'Name',
    email: 'Email',
    emailOnIssue: 'Moloni emails this address when the receipt is issued.',
    copyLink: 'Copy link',
    receipt: 'Receipt',
    linkCopied: 'Invoice link copied.',
    address: 'Address',
    city: 'City',
    postalCode: 'Postal code',
    missingExemption: 'The exemption reason is missing for {{name}}. The invoice was not sent.',
    sent: 'Invoice-receipt issued.',
    resent: 'Moloni will email the invoice-receipt.',
    errors: {
      notConnected: 'Moloni is not connected. Open Invoicing and choose the company and series.',
      missingData: 'A VAT-exempt line is missing the exemption reason. The invoice-receipt was not sent.',
      rejected: 'Moloni rejected the invoice-receipt.',
      invalidVat: 'The VAT number is not valid.',
      failed: 'The invoice-receipt could not be issued.',
      seriesNotRegistered: 'This invoice series is not registered with the Portuguese tax authority for invoice-receipts. In Moloni, communicate the Fatura-recibo series to AT or turn on automatic series communication, then try again.',
    },
  },
};

export const revenueMoloniTranslationsPt = {
  expenses: { tabs: { revenue: 'Receitas', sales: 'Vendas', invoicing: 'Faturação' } },
  revenueReport: {
    downloadPdf: 'Descarregar PDF',
    downloadCsv: 'Descarregar CSV',
    totalReceived: 'Total recebido',
    totalVat: 'Total IVA',
    sales: '{{count}} vendas',
    empty: 'Não há pagamentos neste período.',
    show: 'Mostrar',
    columns: {
      id: 'Id',
      date: 'Data',
      professional: 'Profissional',
      customer: 'Cliente',
      vat: 'NIF cliente',
      services: 'Serviços',
      products: 'Produtos',
      total: 'Total pago',
      tax: 'IVA',
      payment: 'Pagamento',
    },
  },
  salesList: {
    month: 'Mês',
    professionals: 'Profissionais',
    customers: 'Clientes',
    invoiceStatus: 'Estado da fatura',
    allCustomers: 'Todos os clientes',
    issued: 'Emitida',
    notIssued: 'Não emitida',
    all: 'Todas',
    selectAll: 'Selecionar todas',
    issueSelected: 'Emitir seleção',
    selectedCount_one: '{{count}} venda selecionada',
    selectedCount_other: '{{count}} vendas selecionadas',
    empty: 'Não há vendas para estes filtros.',
    progress: 'Emitidas {{issued}}, ignoradas {{skipped}}, falhadas {{failed}}.',
    searchCustomers: 'Pesquisar clientes',
    previous: 'Anterior',
    next: 'Seguinte',
  },
  moloni: {
    title: 'Moloni',
    explanation: 'Ligue a conta Moloni da loja para emitir uma fatura-recibo quando quiser. O pagamento fica registado mesmo que a fatura não seja emitida.',
    connect: 'Ligar à Moloni',
    company: 'Empresa',
    series: 'Série de fatura-recibo',
    noSeries: 'Esta empresa Moloni não tem séries de documentos.',
    save: 'Guardar',
    ready: 'Ligado a {{company}}.',
    changeCompany: 'Alterar empresa',
    disconnect: 'Desligar',
    disconnectTitle: 'Desligar a Moloni',
    disconnectMessage: 'A loja deixa de emitir faturas-recibo. As faturas já emitidas ficam na Moloni.',
    issue: 'Emitir fatura',
    resend: 'Reenviar ao cliente',
    issued: 'Emitida',
    notIssued: 'Não emitida',
    later: 'Agora não',
    confirmTitle: 'Emitir fatura-recibo',
    name: 'Nome',
    email: 'Email',
    emailOnIssue: 'A Moloni envia a fatura-recibo para este email ao emiti-la.',
    copyLink: 'Copiar ligação',
    receipt: 'Recibo',
    linkCopied: 'Ligação da fatura copiada.',
    address: 'Morada',
    city: 'Cidade',
    postalCode: 'Código postal',
    missingExemption: 'Falta o motivo de isenção de {{name}}. A fatura não foi enviada.',
    sent: 'Fatura-recibo emitida.',
    resent: 'A Moloni vai enviar a fatura-recibo por email.',
    errors: {
      notConnected: 'A Moloni não está ligada. Abra Faturação e escolha a empresa e a série.',
      missingData: 'Falta o motivo de isenção numa linha. A fatura-recibo não foi enviada.',
      rejected: 'A Moloni rejeitou a fatura-recibo.',
      invalidVat: 'O NIF não é válido.',
      failed: 'Não foi possível emitir a fatura-recibo.',
      seriesNotRegistered: 'Esta série não está comunicada à Autoridade Tributária para faturas-recibo. No Moloni, comunique a série de fatura-recibo à AT ou ative a comunicação automática de séries e tente novamente.',
    },
  },
};

export const revenueMoloniTranslationsEs = {
  expenses: { tabs: { revenue: 'Ingresos', sales: 'Ventas', invoicing: 'Facturación' } },
  revenueReport: {
    downloadPdf: 'Descargar PDF',
    downloadCsv: 'Descargar CSV',
    totalReceived: 'Total recibido',
    totalVat: 'Total IVA',
    sales: '{{count}} ventas',
    empty: 'No hay pagos en este período.',
    show: 'Mostrar',
    columns: {
      id: 'Id',
      date: 'Fecha',
      professional: 'Profesional',
      customer: 'Cliente',
      vat: 'NIF cliente',
      services: 'Servicios',
      products: 'Productos',
      total: 'Total pagado',
      tax: 'IVA',
      payment: 'Pago',
    },
  },
  salesList: {
    month: 'Mes',
    professionals: 'Profesionales',
    customers: 'Clientes',
    invoiceStatus: 'Estado de la factura',
    allCustomers: 'Todos los clientes',
    issued: 'Emitida',
    notIssued: 'No emitida',
    all: 'Todas',
    selectAll: 'Seleccionar todas',
    issueSelected: 'Emitir selección',
    selectedCount_one: '{{count}} venta seleccionada',
    selectedCount_other: '{{count}} ventas seleccionadas',
    empty: 'No hay ventas para estos filtros.',
    progress: 'Emitidas {{issued}}, omitidas {{skipped}}, fallidas {{failed}}.',
    searchCustomers: 'Buscar clientes',
    previous: 'Anterior',
    next: 'Siguiente',
  },
  moloni: {
    title: 'Moloni',
    explanation: 'Conecta la cuenta Moloni de la tienda para emitir una factura-recibo cuando lo decidas. El pago queda registrado aunque no se emita la factura.',
    connect: 'Conectar con Moloni',
    company: 'Empresa',
    series: 'Serie de factura-recibo',
    noSeries: 'Esta empresa de Moloni no tiene series de documentos.',
    save: 'Guardar',
    ready: 'Conectado a {{company}}.',
    changeCompany: 'Cambiar empresa',
    disconnect: 'Desconectar',
    disconnectTitle: 'Desconectar Moloni',
    disconnectMessage: 'La tienda dejará de emitir facturas-recibo. Las facturas ya emitidas permanecen en Moloni.',
    issue: 'Emitir factura',
    resend: 'Reenviar al cliente',
    issued: 'Emitida',
    notIssued: 'No emitida',
    later: 'Ahora no',
    confirmTitle: 'Emitir factura-recibo',
    name: 'Nombre',
    email: 'Email',
    emailOnIssue: 'Moloni envía la factura-recibo a este email al emitirla.',
    copyLink: 'Copiar enlace',
    receipt: 'Recibo',
    linkCopied: 'Enlace de la factura copiado.',
    address: 'Dirección',
    city: 'Ciudad',
    postalCode: 'Código postal',
    missingExemption: 'Falta el motivo de exención de {{name}}. La factura no se envió.',
    sent: 'Factura-recibo emitida.',
    resent: 'Moloni enviará la factura-recibo por email.',
    errors: {
      notConnected: 'Moloni no está conectado. Abra Facturación y elija la empresa y la serie.',
      missingData: 'Falta el motivo de exención en una línea. La factura-recibo no se envió.',
      rejected: 'Moloni rechazó la factura-recibo.',
      invalidVat: 'El NIF no es válido.',
      failed: 'No se pudo emitir la factura-recibo.',
      seriesNotRegistered: 'Esta serie no está comunicada a la Autoridad Tributaria para facturas-recibo. En Moloni, comunique la serie de factura-recibo a la AT o active la comunicación automática de series e inténtelo de nuevo.',
    },
  },
};
